import React from 'react';

const AboutSection = () => {
  return (
    <section id="about" className="py-32 bg-white">
      <div className="max-w-7xl mx-auto px-8">
        <div className="text-center mb-24">
          <p className="text-emerald-700 text-sm font-medium tracking-widest uppercase mb-6">About Irgiz Export</p>
          <h2 className="text-5xl md:text-6xl font-light text-gray-900 mb-6 tracking-tight">
            International Commodity Trading
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-20 items-center">
          <div>
            <img
              src="https://images.unsplash.com/photo-1758873115193-bc8eab1b87bf"
              alt="Agricultural harvest and export logistics"
              className="w-full h-[500px] object-cover shadow-2xl"
            />
          </div>

          <div className="space-y-8">
            <p className="text-xl text-gray-600 leading-relaxed font-light">
              Irgiz Export LLP is an agricultural export company based in Kazakhstan specializing in the supply of agricultural commodities to international markets.
            </p>
            
            <p className="text-xl text-gray-600 leading-relaxed font-light">
              We work directly with agricultural producers in Northern Kazakhstan and focus on international commodity trading with a particular emphasis on oilseeds.
            </p>
            
            <p className="text-xl text-gray-600 leading-relaxed font-light">
              Our company organizes complete export logistics and builds long-term partnerships with international trading companies and processors.
            </p>

            <div className="pt-8 border-t border-gray-200">
              <p className="text-emerald-800 font-medium text-lg">
                Reliable sourcing • Export logistics • Quality assurance
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
